import {immutableSplice} from 'common/util/array';

import {SidenavSection, SidenavSectionItem} from './types';

/**
 * Move item with value itemValue to a different section or position
 */
export function moveSidenavItem(
  sections: SidenavSection[],
  sectionIndex: number,
  itemIndex: number,
  destinationSectionIndex: number,
  destinationItemIndex: number,
) {
  const item = {...sections[sectionIndex].items[itemIndex]};
  return sidenavItemSplice(
    sidenavItemSplice(sections, sectionIndex, itemIndex, 1),
    destinationSectionIndex,
    destinationItemIndex,
    0,
    item,
  );
}

export function sidenavItemSplice<T extends SidenavSection>(
  sections: T[],
  sectionIndex: number,
  ...args: [itemIndex?: number, numToDelete?: number, itemToInsert?: SidenavSectionItem]
): T[] {
  return immutableSplice(sections, sectionIndex, 1, {
    ...sections[sectionIndex],
    items: immutableSplice(sections[sectionIndex].items, ...args),
  });
}

export function findSidenavIndices(
  sections: SidenavSection[],
  predicate: (section: SidenavSection, item: SidenavSectionItem) => boolean,
): {sectionIndex: number; itemIndex: number} {
  for (const [sectionIndex, section] of sections.entries()) {
    for (const [itemIndex, item] of section.items.entries()) {
      if (predicate(section, item)) {
        return {sectionIndex, itemIndex};
      }
    }
  }

  return {sectionIndex: -1, itemIndex: -1};
}

export function findAllSidenavIndices(
  sections: SidenavSection[],
  predicate: (section: SidenavSection, item: SidenavSectionItem) => boolean,
): Array<{sectionIndex: number; itemIndex: number}> {
  const indices = [];
  for (const [sectionIndex, section] of sections.entries()) {
    for (const [itemIndex, item] of section.items.entries()) {
      if (predicate(section, item)) {
        indices.push({sectionIndex, itemIndex});
      }
    }
  }
  return indices;
}
